export const TOTAL = "Total";
